export default __webpack_public_path__ + "static/media/petronas_logo_2.0e464aa8.svg";